import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { IProjectsImage } from '../../../interfaces/interfaces';
import carouselStyle from './ImagesCarousel.module.scss';

interface IProps {
    images: IProjectsImage[];
    name?: string;
}

const ImagesCarousle = (props: IProps) => {
    const { images, name = '' } = props;

    return (
        <div className={carouselStyle.wrapper}>
            <Carousel showStatus={false} showThumbs={images.length > 1} infiniteLoop useKeyboardArrows swipeable emulateTouch>
                {images?.map((image, i) => (
                    <div key={i} className={carouselStyle.slide}>
                        <img src={image.image} alt={name ? `${name} screenshot ${i + 1}` : ''} />
                    </div>
                ))}
            </Carousel>
        </div>
    );
};

export default ImagesCarousle;
